import { render, staticRenderFns } from "./ContactFormCard.vue?vue&type=template&id=9c0296f0&scoped=true"
import script from "./ContactFormCard.vue?vue&type=script&lang=js"
export * from "./ContactFormCard.vue?vue&type=script&lang=js"
import style0 from "./ContactFormCard.vue?vue&type=style&index=0&id=9c0296f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c0296f0",
  null
  
)

export default component.exports